// Google initialization

Jelly.Connections.Google_Client_ID = "351154443072-0nvldf11qe5dc13dlf7hfator1g2ks3t.apps.googleusercontent.com";
Jelly.Connections.Google_Pending_Sign_In_Key = "Jelly.Google.Pending.Sign.In";
Jelly.Connections.Google_Pending_Sign_In_Max_Age = 15 * 60 * 1000;
Jelly.Connections.Google_Auth = null;
Jelly.Connections.Google_Auth_Ready = false;
Jelly.Connections.Google_Ready_Queue = [];
Jelly.Connections.Google_Modal_Restore_Attempted = false;
Jelly.Connections.Google_Resume_Listeners = {};
Jelly.Connections.Google_Redirect_Overlay_ID = "WF_Google_Redirect_Overlay";
Jelly.Connections.Google_Redirect_Lifecycle = null;
// Connecting an existing social identity can take longer than a new sign-in
// because Jelly may reconcile the existing person before returning its
// navigation scripts. Keep a bounded recovery path, but do not abort a valid
// repeated-account sign-in while that work is still in flight.
Jelly.Connections.Google_Redirect_Timeout = 30000;
Jelly.Connections.Google_Prepaint_Navigation_Timeout = null;

Jelly.Connections.Google_Is_Redirect_Callback_Path = function(Pathname) {
	return /^\/action\/(?:\d+\/)?(?:sign_in|sign_up)\/modal$/.test(Pathname || "");
};

Jelly.Connections.Google_Normalize_Pathname_For_Comparison = function(Pathname) {
	if (!Pathname)
		return Pathname;

	Pathname = Pathname.replace(/\/:.*/, "");
	Pathname = Pathname.replace(/^\/action\/\d+\/(sign_in|sign_up)(\/modal)?$/, "/action/$1$2");

	return Pathname;
};

Jelly.Connections.Google_Fragment_Matches_Pending_Redirect = function(Pairs, Pathname) {
	var Pending_Sign_In = null;
	var Pending_Sign_In_Text = null;

	try {
		Pending_Sign_In_Text = window.sessionStorage.getItem(Jelly.Connections.Google_Pending_Sign_In_Key);
		Pending_Sign_In = Pending_Sign_In_Text ? JSON.parse(Pending_Sign_In_Text) : null;
	}
	catch (Error) {
		return false;
	}

	if (
		!Pending_Sign_In ||
		!Pending_Sign_In.State ||
		!Pending_Sign_In.Pathname ||
		!Pending_Sign_In.Created_At ||
		typeof Pending_Sign_In.State != "string" ||
		typeof Pending_Sign_In.Pathname != "string" ||
		typeof Pending_Sign_In.Created_At != "number" ||
		(Date.now() - Pending_Sign_In.Created_At) > Jelly.Connections.Google_Pending_Sign_In_Max_Age
	)
		return false;

	return !!(
		Pairs &&
		Pairs.state == Pending_Sign_In.State &&
		Jelly.Connections.Google_Normalize_Pathname_For_Comparison(Pending_Sign_In.Pathname) ==
			Jelly.Connections.Google_Normalize_Pathname_For_Comparison(Pathname)
	);
};

// Captured on bundle load: if we just returned from a Google redirect the
// id_token sits in window.location.hash and the deprecated gapi.auth2
// redirect flow no longer reads it, so we grab it on fixed Google callback
// routes or when a pending flow owns the current state and path. Other OAuth
// integrations also return access_token fragments and must consume their own.
Jelly.Connections.Google_Captured_Redirect = (function() {
	var Hash = window.location.hash;
	var Body = null;
	var Parts = null;
	var Pairs = {};
	var Captured_Pathname = null;

	if (!Hash || Hash.length < 2)
		return null;

	Body = Hash.charAt(0) == "#" ? Hash.substring(1) : Hash;
	Parts = Body.split("&");

	for (var Index = 0; Index < Parts.length; Index++) {
		var Pair = Parts[Index].split("=");
		if (Pair.length < 2)
			continue;
		try {
			Pairs[decodeURIComponent(Pair[0])] = decodeURIComponent(Pair.slice(1).join("="));
		}
		catch (Error) {
			continue;
		}
	}

	// A state-only fragment is a normal in-page anchor often used by Jelly;
	// only capture fragments that contain an OAuth response signal. State is
	// still validated below when it accompanies that response.
	if (!Pairs.id_token && !Pairs.access_token && !Pairs.error)
		return null;

	if (
		!Jelly.Connections.Google_Is_Redirect_Callback_Path(window.location.pathname) &&
		!Jelly.Connections.Google_Fragment_Matches_Pending_Redirect(Pairs, window.location.pathname)
	)
		return null;

	Captured_Pathname = window.location.pathname;

	if (window.history && window.history.replaceState) {
		try {
			window.history.replaceState(
				null,
				"",
				window.location.pathname + window.location.search
			);
		}
		catch (Error) {
		}
	}

	return {
		Tokens: Pairs,
		Pathname: Captured_Pathname,
		Is_Callback: true
	};
})();

Jelly.Connections.Google_Parse_ID_Token = function(ID_Token) {
	var Parts = null;
	var Payload = null;

	if (!ID_Token)
		return null;

	Parts = ID_Token.split(".");

	if (Parts.length < 2)
		return null;

	Payload = Parts[1].replace(/-/g, "+").replace(/_/g, "/");

	while (Payload.length % 4)
		Payload += "=";

	try {
		return JSON.parse(atob(Payload));
	}
	catch (Error) {
		return null;
	}
};

Jelly.Connections.Google_Create_Random_Token = function() {
	var Bytes = null;
	var Values = [];

	if (window.crypto && window.crypto.getRandomValues) {
		Bytes = new Uint8Array(16);
		window.crypto.getRandomValues(Bytes);

		for (var Index = 0; Index < Bytes.length; Index++)
			Values.push(("0" + Bytes[Index].toString(16)).slice(-2));

		return Values.join("");
	}

	return String(Date.now()) + String(Math.random()).replace(/\D/g, "");
};

Jelly.Connections.Google_Profile_Needs_Userinfo = function(Profile) {
	return !(
		Profile &&
		Profile.name &&
		Profile.given_name &&
		Profile.family_name
	);
};

Jelly.Connections.Google_Merge_Profile = function(Profile, Extra_Profile) {
	var Fields = [
		"sub",
		"email",
		"name",
		"given_name",
		"family_name",
		"picture"
	];

	Profile = Profile || {};
	Extra_Profile = Extra_Profile || {};

	$.each(Fields, function(Field_Index, Field) {
		if (!Profile[Field] && Extra_Profile[Field])
			Profile[Field] = Extra_Profile[Field];
	});

	return Profile;
};

Jelly.Connections.Google_Fetch_Userinfo_Profile = function(Access_Token, Callback) {
	var Completed = false;
	var Finish = function(Profile) {
		if (Completed)
			return;

		Completed = true;
		Callback(Profile || {});
	};

	if (!Access_Token) {
		Finish(null);
		return;
	}

	$.ajax({
		url: "https://www.googleapis.com/oauth2/v3/userinfo",
		dataType: "json",
		headers: {
			Authorization: "Bearer " + Access_Token
		},
		timeout: 3000,
		success: function(Profile) {
			Finish(Profile);
		},
		error: function() {
			Finish(null);
		}
	});
};

Jelly.Connections.Google_Submit_Redirect_Profile = function(Parameters, Pending_Sign_In, Profile, Lifecycle) {
	if (Lifecycle && Lifecycle.Finished)
		return;

	Jelly.Connections.Google_Handle_Redirect_Profile(
		{
			Namespace: Parameters.Namespace,
			Error_Namespace: Parameters.Error_Namespace || Pending_Sign_In.Error_Namespace
		},
		Profile,
		Lifecycle
	);
};

Jelly.Connections.Google_Get_Event_Intent = function(Parameters, Pending_Sign_In) {
	var Intent = (Pending_Sign_In && Pending_Sign_In.Intent) || Parameters.Intent || "";

	if (Intent == "Sign In")
		return "sign_in";

	if (Intent == "Sign Up")
		return "sign_up";

	return "connection";
};

Jelly.Connections.Google_Normalize_Failure_Reason = function(Reason) {
	var Allowed_Reasons = {
		denied: true,
		invalid_callback: true,
		invalid_state: true,
		invalid_nonce: true,
		profile_unavailable: true,
		action_failed: true,
		timeout: true
	};

	if (Allowed_Reasons[Reason])
		return Reason;

	return "invalid_callback";
};

Jelly.Connections.Google_Track_Redirect_Event = function(Lifecycle, Event_Name, Reason) {
	var Properties = null;

	if (!Lifecycle || Lifecycle.Events[Event_Name])
		return;

	Lifecycle.Events[Event_Name] = true;
	Properties = {
		intent: Lifecycle.Intent
	};

	if (Event_Name == "Failed")
		Properties.reason = Jelly.Connections.Google_Normalize_Failure_Reason(Reason);

	try {
		if (window.posthog && typeof window.posthog.capture == "function")
			window.posthog.capture("Google OAuth " + Event_Name, Properties);
	}
	catch (Error) {
		// Analytics must never prevent an OAuth redirect or recovery path.
	}
};

Jelly.Connections.Google_Save_Pending_Sign_In = function(Pending_Sign_In) {
	try {
		window.sessionStorage.setItem(
			Jelly.Connections.Google_Pending_Sign_In_Key,
			JSON.stringify(Pending_Sign_In)
		);
	}
	catch (Error) {
	}
};

Jelly.Connections.Google_Track_Pending_Event = function(Pending_Sign_In, Event_Name) {
	var Lifecycle = null;

	if (!Pending_Sign_In)
		return;

	if (!Pending_Sign_In.Events)
		Pending_Sign_In.Events = {};

	if (Pending_Sign_In.Events[Event_Name])
		return;

	Pending_Sign_In.Events[Event_Name] = true;
	Lifecycle = {
		Events: {},
		Intent: Jelly.Connections.Google_Get_Event_Intent({}, Pending_Sign_In)
	};

	Jelly.Connections.Google_Track_Redirect_Event(Lifecycle, Event_Name);
	Jelly.Connections.Google_Save_Pending_Sign_In(Pending_Sign_In);
};

Jelly.Connections.Google_Create_Redirect_Lifecycle = function(Parameters, Pending_Sign_In) {
	var Lifecycle = Jelly.Connections.Google_Redirect_Lifecycle;

	if (Lifecycle && !Lifecycle.Finished)
		return Lifecycle;

	Lifecycle = {
		Events: {},
		Intent: Jelly.Connections.Google_Get_Event_Intent(Parameters, Pending_Sign_In),
		Parameters: Parameters,
		Pending_Sign_In: Pending_Sign_In || null,
		Finished: false,
		Timeout: null,
		Navigation_Timeout: null,
		Request: null,
		Timed_Out: false
	};
	Jelly.Connections.Google_Redirect_Lifecycle = Lifecycle;
	Jelly.Connections.Google_Track_Redirect_Event(Lifecycle, "Callback received");

	return Lifecycle;
};

Jelly.Connections.Google_Clear_Redirect_Timeout = function(Lifecycle) {
	if (Lifecycle && Lifecycle.Timeout) {
		clearTimeout(Lifecycle.Timeout);
		Lifecycle.Timeout = null;
	}

	if (Lifecycle && Lifecycle.Navigation_Timeout) {
		clearTimeout(Lifecycle.Navigation_Timeout);
		Lifecycle.Navigation_Timeout = null;
	}
};

Jelly.Connections.Google_Remove_Prepaint = function() {
	if (document.documentElement)
		document.documentElement.className = document.documentElement.className.replace(/\bWF_Google_OAuth_Callback_Prepaint\b/g, "").trim();

	window.WF_Google_OAuth_Callback_Prepaint = false;
};

// Some successful Connect Social responses replace the callback page with the
// React dashboard before that page's Google_Sign_In binding runs. In that fast
// path there is no redirect lifecycle to clean up the head-level prepaint, so
// watch the route itself and reveal the destination as soon as navigation wins.
Jelly.Connections.Google_Watch_Prepaint_Navigation = function() {
	var Watch_Navigation = function() {
		var HTML_Class = document.documentElement ? document.documentElement.className : "";
		var Is_Callback_Path = Jelly.Connections.Google_Is_Redirect_Callback_Path(window.location.pathname);

		if (!/\bWF_Google_OAuth_Callback_Prepaint\b/.test(HTML_Class)) {
			Jelly.Connections.Google_Prepaint_Navigation_Timeout = null;
			return;
		}

		if (!Is_Callback_Path || /\bwf-consumer-dashboard-root\b/.test(HTML_Class)) {
			var Overlay = document.getElementById(Jelly.Connections.Google_Redirect_Overlay_ID);
			if (Overlay && Overlay.parentNode)
				Overlay.parentNode.removeChild(Overlay);
			Jelly.Connections.Google_Remove_Prepaint();
			Jelly.Connections.Google_Prepaint_Navigation_Timeout = null;
			return;
		}

		Jelly.Connections.Google_Prepaint_Navigation_Timeout = setTimeout(Watch_Navigation, 100);
	};

	if (
		document.documentElement &&
		/\bWF_Google_OAuth_Callback_Prepaint\b/.test(document.documentElement.className) &&
		!Jelly.Connections.Google_Prepaint_Navigation_Timeout
	)
		Jelly.Connections.Google_Prepaint_Navigation_Timeout = setTimeout(Watch_Navigation, 100);
};

Jelly.Connections.Google_Watch_Prepaint_Navigation();

Jelly.Connections.Google_Show_Redirect_Overlay = function() {
	var Parent = document.body || document.documentElement;
	var Overlay = null;
	var Spinner = null;
	var Label = null;

	if (!Parent)
		return;

	if (document.getElementById(Jelly.Connections.Google_Redirect_Overlay_ID)) {
		Jelly.Connections.Google_Remove_Prepaint();
		return;
	}

	Overlay = document.createElement("div");
	Overlay.id = Jelly.Connections.Google_Redirect_Overlay_ID;
	Overlay.setAttribute("role", "status");
	Overlay.setAttribute("aria-live", "assertive");
	Overlay.setAttribute(
		"style",
		"position:fixed;top:0;right:0;bottom:0;left:0;background:#fff;" +
		"z-index:2147483647;visibility:visible!important;display:flex;align-items:center;" +
		"justify-content:center;flex-direction:column;"
	);

	Spinner = document.createElement("div");
	Spinner.setAttribute(
		"style",
		"width:2.5rem;height:2.5rem;border:3px solid #e0e0e0;" +
		"border-top-color:#333;border-radius:50%;" +
		"animation:WF_Google_Redirect_Spin 0.9s linear infinite;"
	);

	Label = document.createElement("p");
	Label.id = "WF_Google_Redirect_Overlay_Label";
	Label.textContent = "Signing you in\u2026";
	Label.setAttribute(
		"style",
		"margin-top:1.5rem;font-size:1.125rem;color:#333;" +
		"font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;"
	);

	if (!document.getElementById("WF_Google_Redirect_Overlay_Style")) {
		var Style = document.createElement("style");
		Style.id = "WF_Google_Redirect_Overlay_Style";
		Style.textContent =
			"@keyframes WF_Google_Redirect_Spin { " +
			"to { transform: rotate(360deg); } }";
		document.head.appendChild(Style);
	}

	Overlay.appendChild(Spinner);
	Overlay.appendChild(Label);
	Parent.appendChild(Overlay);

	// Swap the prepaint for the runtime overlay only after the latter is in the
	// DOM. This avoids a frame where Jelly's ordinary page loaders become visible.
	Jelly.Connections.Google_Remove_Prepaint();
};

Jelly.Connections.Google_Hide_Redirect_Overlay = function() {
	var Overlay = document.getElementById(Jelly.Connections.Google_Redirect_Overlay_ID);

	if (Overlay && Overlay.parentNode)
		Overlay.parentNode.removeChild(Overlay);

	Jelly.Connections.Google_Remove_Prepaint();
};

Jelly.Connections.Google_Show_Redirect_Recovery = function() {
	var Overlay = document.getElementById(Jelly.Connections.Google_Redirect_Overlay_ID);
	var Spinner = null;
	var Label = null;
	var Details = null;
	var Retry = null;
	var Fallback = null;

	Jelly.Connections.Google_Show_Redirect_Overlay();
	Overlay = document.getElementById(Jelly.Connections.Google_Redirect_Overlay_ID);

	if (!Overlay)
		return;

	Spinner = Overlay.firstChild;
	Label = document.getElementById("WF_Google_Redirect_Overlay_Label");

	if (Spinner)
		Spinner.style.display = "none";

	if (Label)
		Label.textContent = "We couldn't sign you in with Google.";

	Details = document.createElement("p");
	Details.textContent = "Please try again or use your email address instead.";
	Details.setAttribute(
		"style",
		"max-width:22rem;margin:0.5rem 1.5rem 1.5rem;text-align:center;color:#555;" +
		"font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;"
	);

	Retry = document.createElement("button");
	Retry.type = "button";
	Retry.textContent = "Try again";
	Retry.setAttribute(
		"style",
		"margin:0.25rem;padding:0.7rem 1rem;border:0;border-radius:4px;" +
		"background:#333;color:#fff;font-size:1rem;cursor:pointer;"
	);
	Retry.addEventListener("click", function() {
		window.location.reload();
	});

	Fallback = document.createElement("button");
	Fallback.type = "button";
	Fallback.textContent = "Use email instead";
	Fallback.setAttribute(
		"style",
		"margin:0.25rem;padding:0.7rem 1rem;border:1px solid #333;border-radius:4px;" +
		"background:#fff;color:#333;font-size:1rem;cursor:pointer;"
	);
	Fallback.addEventListener("click", function() {
		Jelly.Connections.Google_Hide_Redirect_Overlay();
		var Email_Input = document.querySelector("input[name='Email_Address'], input[name='Account_Email_Address']");
		if (Email_Input)
			Email_Input.focus();
	});

	Overlay.appendChild(Details);
	Overlay.appendChild(Retry);
	Overlay.appendChild(Fallback);
};

Jelly.Connections.Google_Fail_Redirect = function(Parameters, Lifecycle, Reason) {
	var Pending_Sign_In = Lifecycle && Lifecycle.Pending_Sign_In;

	if (!Lifecycle)
		Lifecycle = Jelly.Connections.Google_Create_Redirect_Lifecycle(Parameters, Pending_Sign_In);

	// A successful sign-in response can navigate before the request's completion
	// callback runs. Do not let that late failure or timeout cover the dashboard
	// with recovery UI after authentication already succeeded.
	if (
		Lifecycle.Pending_Sign_In &&
		Jelly.Connections.Google_Normalize_Pathname_For_Comparison(window.location.pathname) !=
			Lifecycle.Pending_Sign_In.Pathname
	) {
		Jelly.Connections.Google_Complete_Redirect(Lifecycle);
		return;
	}

	if (Lifecycle.Finished)
		return;

	Lifecycle.Finished = true;
	Jelly.Connections.Google_Clear_Redirect_Timeout(Lifecycle);
	Lifecycle.Request = null;
	Jelly.Connections.Google_Clear_Pending_Sign_In();
	Jelly.Connections.Google_Captured_Redirect = null;
	Jelly.Connections.Google_Track_Redirect_Event(Lifecycle, "Failed", Reason);
	Jelly.Connections.Google_Show_Redirect_Recovery();
};

Jelly.Connections.Google_Reject_Redirect = function(Parameters, Lifecycle, Reason) {
	Jelly.Connections.Google_Captured_Redirect = null;

	if (Lifecycle) {
		Jelly.Connections.Google_Fail_Redirect(Parameters, Lifecycle, Reason);
		return;
	}

	Jelly.Connections.Google_Clear_Pending_Sign_In();
	Jelly.Connections.Google_Show_Error(
		Parameters,
		"Sorry! We were unable to log you in through Google."
	);
};

Jelly.Connections.Google_Complete_Redirect = function(Lifecycle) {
	if (!Lifecycle || Lifecycle.Finished)
		return;

	Lifecycle.Finished = true;
	Jelly.Connections.Google_Clear_Redirect_Timeout(Lifecycle);
	Lifecycle.Request = null;
	Jelly.Connections.Google_Clear_Pending_Sign_In();
	Jelly.Connections.Google_Track_Redirect_Event(Lifecycle, "Completed");
	Jelly.Connections.Google_Hide_Redirect_Overlay();
};

Jelly.Connections.Google_Start_Redirect_Timeout = function(Parameters, Lifecycle) {
	if (!Lifecycle || Lifecycle.Timeout || Lifecycle.Finished)
		return;

	Lifecycle.Timeout = setTimeout(function() {
		Lifecycle.Timed_Out = true;
		if (Lifecycle.Request && Lifecycle.Request.abort) {
			Lifecycle.Request.Jelly_No_Retry = true;
			Lifecycle.Request.abort();
		}
		Jelly.Connections.Google_Fail_Redirect(Parameters, Lifecycle, "timeout");
	}, Jelly.Connections.Google_Redirect_Timeout);

	var Watch_Navigation = function() {
		if (!Lifecycle || Lifecycle.Finished)
			return;

		if (
			Lifecycle.Pending_Sign_In &&
			Jelly.Connections.Google_Normalize_Pathname_For_Comparison(window.location.pathname) !=
				Lifecycle.Pending_Sign_In.Pathname
		) {
			Jelly.Connections.Google_Complete_Redirect(Lifecycle);
			return;
		}

		Lifecycle.Navigation_Timeout = setTimeout(Watch_Navigation, 100);
	};

	Lifecycle.Navigation_Timeout = setTimeout(Watch_Navigation, 100);
};

Jelly.Connections.Google_Execute_Redirect_Action = function(Parameters, Target, Lifecycle) {
	if (Lifecycle && Lifecycle.Finished)
		return;

	if (!Target) {
		Jelly.Connections.Google_Fail_Redirect(Parameters, Lifecycle, "action_failed");
		return;
	}

	if (!Lifecycle) {
		Jelly.Handlers.Call_Handler_For_Target({
			Event: "Execute",
			Target: Target
		});
		return;
	}

	Jelly.Connections.Google_Start_Redirect_Timeout(Parameters, Lifecycle);
	Jelly.Actions.Execute_By_Namespace({
		Namespace: Parameters.Namespace,
		On_Success: function() {
			Jelly.Connections.Google_Complete_Redirect(Lifecycle);
		},
		On_Failure: function() {
			Jelly.Connections.Google_Fail_Redirect(
				Parameters,
				Lifecycle,
				Lifecycle.Timed_Out ? "timeout" : "action_failed"
			);
		},
		On_Request: function(Request) {
			Lifecycle.Request = Request;
		},
		Should_Ignore_Completion: function() {
			return Lifecycle.Finished;
		}
	});
};

Jelly.Connections.Google_Handle_Redirect_Profile = function(Parameters, Profile, Lifecycle) {
	var Namespace = Parameters.Namespace;
	var Target = document.getElementById(Namespace);

	if (Lifecycle && Lifecycle.Finished)
		return;

	if (!Profile || !Profile.sub || !Profile.email) {
		if (Lifecycle)
			Jelly.Connections.Google_Fail_Redirect(Parameters, Lifecycle, "profile_unavailable");
		else
			Jelly.Connections.Google_Show_Error(
				Parameters,
				"Sorry! We were unable to log you in through Google."
			);
		return;
	}

	if (!Lifecycle)
		Jelly.Connections.Google_Clear_Pending_Sign_In();

	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Account_Platform",
		Value: "Google"
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Account_ID",
		Value: Profile.sub || ""
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Email_Address",
		Value: Profile.email || ""
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Person_Name",
		Value: Profile.name || ""
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "First_Name",
		Value: Profile.given_name || ""
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Last_Name",
		Value: Profile.family_name || ""
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Picture_URL",
		Value: Profile.picture || ""
	});

	Jelly.Connections.Google_Execute_Redirect_Action(Parameters, Target, Lifecycle);
};

Jelly.Connections.Google_When_Ready = function(Callback) {
	if (Jelly.Connections.Google_Auth_Ready && Jelly.Connections.Google_Auth) {
		Callback(Jelly.Connections.Google_Auth);
		return;
	}

	Jelly.Connections.Google_Ready_Queue.push(Callback);
};

Jelly.Connections.Google_Run_Ready_Queue = function() {
	var Queue = Jelly.Connections.Google_Ready_Queue.slice(0);
	Jelly.Connections.Google_Ready_Queue = [];

	$.each(Queue, function(Queue_Index, Callback) {
		Callback(Jelly.Connections.Google_Auth);
	});
};

Jelly.Connections.Google_Get_Origin = function() {
	return window.location.protocol + "//" + window.location.host;
};

Jelly.Connections.Google_Get_Intent_Redirect_Path = function(Intent) {
	if (Intent == "Sign In")
		return "/action/363/sign_in/modal";

	if (Intent == "Sign Up")
		return "/action/364/sign_up/modal";

	return null;
};

Jelly.Connections.Google_Normalize_Redirect_URL = function(URL) {
	var Parser = document.createElement("a");
	var Pathname = null;

	if (!URL)
		return Jelly.Connections.Google_Get_Origin() + window.location.pathname;

	Parser.href = URL;
	Pathname = Parser.pathname || window.location.pathname;
	Pathname = Pathname.replace(/\/:.*/, "");

	if (Pathname.charAt(0) != "/")
		Pathname = "/" + Pathname;

	return Jelly.Connections.Google_Get_Origin() + Pathname;
};

Jelly.Connections.Google_Get_Redirect_URL = function(Parameters) {
	var Intent_Redirect_Path = Jelly.Connections.Google_Get_Intent_Redirect_Path(Parameters.Intent);
	var Redirect_URL = null;

	if (Intent_Redirect_Path)
		Redirect_URL = Jelly.Connections.Google_Get_Origin() + Intent_Redirect_Path;

	if (Redirect_URL)
		return Redirect_URL;

	if (Jelly.Interface.Visible_Modal && Jelly.Interface.Visible_Modal.URL)
		return Jelly.Connections.Google_Normalize_Redirect_URL(Jelly.Interface.Visible_Modal.URL);

	return Jelly.Connections.Google_Get_Origin() + window.location.pathname;
};

Jelly.Connections.Google_Uses_Callback_Page = function(Pending_Sign_In) {
	return Pending_Sign_In && (
		Pending_Sign_In.Intent == "Sign In" ||
		Pending_Sign_In.Intent == "Sign Up"
	);
};

Jelly.Connections.Google_Get_Pending_Sign_In = function() {
	var Pending_Sign_In = null;
	var Pending_Sign_In_Text = null;

	try {
		Pending_Sign_In_Text = window.sessionStorage.getItem(Jelly.Connections.Google_Pending_Sign_In_Key);
	}
	catch (Error) {
		return null;
	}

	if (!Pending_Sign_In_Text)
		return null;

	try {
		Pending_Sign_In = JSON.parse(Pending_Sign_In_Text);
	}
	catch (Error) {
		Jelly.Connections.Google_Clear_Pending_Sign_In();
		return null;
	}

	if (
		!Pending_Sign_In ||
		!Pending_Sign_In.Namespace ||
		!Pending_Sign_In.Pathname ||
		!Pending_Sign_In.Created_At ||
		typeof Pending_Sign_In.Namespace != "string" ||
		typeof Pending_Sign_In.Pathname != "string" ||
		typeof Pending_Sign_In.Created_At != "number"
	) {
		Jelly.Connections.Google_Clear_Pending_Sign_In();
		return null;
	}

	Pending_Sign_In.Pathname = Jelly.Connections.Google_Normalize_Pathname_For_Comparison(Pending_Sign_In.Pathname);

	if ((Date.now() - Pending_Sign_In.Created_At) > Jelly.Connections.Google_Pending_Sign_In_Max_Age) {
		Jelly.Connections.Google_Clear_Pending_Sign_In();
		return null;
	}

	return Pending_Sign_In;
};

Jelly.Connections.Google_Set_Pending_Sign_In = function(Parameters) {
	var Redirect_URL = Jelly.Connections.Google_Get_Redirect_URL(Parameters);
	var Pending_Sign_In = {
		Namespace: Parameters.Namespace,
		Error_Namespace: Parameters.Error_Namespace || "",
		Intent: Parameters.Intent || "",
		Pathname: Redirect_URL.replace(Jelly.Connections.Google_Get_Origin(), ""),
		Redirect_URL: Redirect_URL,
		Source_Pathname: window.location.pathname,
		State: Jelly.Connections.Google_Create_Random_Token(),
		Nonce: Jelly.Connections.Google_Create_Random_Token(),
		Created_At: Date.now()
	};

	if (Jelly.Interface.Visible_Modal && Jelly.Interface.Visible_Modal.URL) {
		Pending_Sign_In.Modal_URL = Jelly.Interface.Visible_Modal.URL;
		Pending_Sign_In.Modal_Direction = $(Jelly.Interface.Visible_Modal.Control_Element).hasClass("Overlay") ? "Up" : "Right";
		Pending_Sign_In.Modal_2019_Theme = $(Jelly.Interface.Visible_Modal.Control_Element).hasClass("wf-modal-wrapper");
		Pending_Sign_In.Modal_Force_Minimal = $(Jelly.Interface.Visible_Modal.Control_Element).hasClass("Force_Minimal_Wrapper");
	}

	Jelly.Connections.Google_Save_Pending_Sign_In(Pending_Sign_In);

	return Pending_Sign_In;
};

Jelly.Connections.Google_Get_Authorize_URL = function(Pending_Sign_In) {
	var Query = [
		["client_id", Jelly.Connections.Google_Client_ID],
		["redirect_uri", Pending_Sign_In.Redirect_URL],
		// Authentication needs the ID token only. Requesting an OAuth access token
		// can re-surface historical Google API (for example Drive) grants belonging
		// to this shared client, and exposes that token in the callback URL.
		["response_type", "id_token"],
		["scope", "openid profile email"],
		["state", Pending_Sign_In.State],
		["nonce", Pending_Sign_In.Nonce]
	];
	var Parts = [];

	$.each(Query, function(Query_Index, Pair) {
		Parts.push(encodeURIComponent(Pair[0]) + "=" + encodeURIComponent(Pair[1]));
	});

	return "https://accounts.google.com/o/oauth2/v2/auth?" + Parts.join("&");
};

Jelly.Connections.Google_Clear_Pending_Sign_In = function() {
	try {
		window.sessionStorage.removeItem(Jelly.Connections.Google_Pending_Sign_In_Key);
	}
	catch (Error) {
	}
};

Jelly.Connections.Google_Show_Error = function(Parameters, Content) {
	var Error_Namespace = Parameters.Error_Namespace || Parameters.Namespace;

	Jelly.Actions.Show_Result({
		Namespace: Error_Namespace,
		Content: Content
	});
};

Jelly.Connections.Google_Handle_Success = function(Parameters, googleUser) {
	var google_profile = googleUser.getBasicProfile();
	var Namespace = Parameters.Namespace;

	Jelly.Connections.Google_Clear_Pending_Sign_In();

	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Account_Platform",
		Value: "Google"
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Account_ID",
		Value: google_profile.getId()
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Email_Address",
		Value: google_profile.getEmail()
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Person_Name",
		Value: google_profile.getName()
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "First_Name",
		Value: google_profile.getGivenName()
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Last_Name",
		Value: google_profile.getFamilyName()
	});
	Jelly.Actions.Set_Input_Value({
		Namespace: Namespace,
		Alias: "Picture_URL",
		Value: google_profile.getImageUrl()
	});

	Jelly.Handlers.Call_Handler_For_Target({
		Event: "Execute",
		Target: document.getElementById(Namespace)
	});
};

Jelly.Connections.Google_Try_Resume_Sign_In = function(Parameters) {
	var Google_User = null;
	var Pending_Sign_In = Jelly.Connections.Google_Get_Pending_Sign_In();
	var Captured = Jelly.Connections.Google_Captured_Redirect;
	var Effective_Pathname = Captured ? Captured.Pathname : window.location.pathname;
	var Profile = null;
	var Lifecycle = null;
	var Is_Callback_Page = Captured &&
		Jelly.Connections.Google_Uses_Callback_Page({Intent: Parameters.Intent});

	if (!Pending_Sign_In) {
		if (Is_Callback_Page)
			Jelly.Connections.Google_Fail_Redirect(Parameters, null, "invalid_callback");
		return;
	}

	if (
		Pending_Sign_In.Modal_URL &&
		!Jelly.Interface.Visible_Modal &&
		!Jelly.Connections.Google_Uses_Callback_Page(Pending_Sign_In)
	)
		return;

	if (Pending_Sign_In.Intent && Parameters.Intent && Pending_Sign_In.Intent != Parameters.Intent) {
		if (Is_Callback_Page)
			Jelly.Connections.Google_Fail_Redirect(Parameters, null, "invalid_callback");
		return;
	}

	if (!Pending_Sign_In.Intent && Pending_Sign_In.Namespace != Parameters.Namespace) {
		if (Is_Callback_Page)
			Jelly.Connections.Google_Fail_Redirect(Parameters, null, "invalid_callback");
		return;
	}

	if (
		Pending_Sign_In.Pathname !=
		Jelly.Connections.Google_Normalize_Pathname_For_Comparison(Effective_Pathname)
	) {
		if (Is_Callback_Page)
			Jelly.Connections.Google_Fail_Redirect(Parameters, null, "invalid_callback");
		return;
	}

	if (Captured && Jelly.Connections.Google_Uses_Callback_Page(Pending_Sign_In)) {
		Lifecycle = Jelly.Connections.Google_Create_Redirect_Lifecycle(
			Parameters,
			Pending_Sign_In
		);
		Jelly.Connections.Google_Start_Redirect_Timeout(Parameters, Lifecycle);
	}

	if (
		Pending_Sign_In.State &&
		Captured &&
		Captured.Tokens &&
		Captured.Tokens.state != Pending_Sign_In.State
	) {
		Jelly.Connections.Google_Reject_Redirect(
			Parameters,
			Lifecycle,
			"invalid_state"
		);
		return;
	}

	if (Captured && Captured.Tokens && Captured.Tokens.error) {
		Jelly.Connections.Google_Reject_Redirect(
			Parameters,
			Lifecycle,
			"denied"
		);
		return;
	}

	// Prefer the id_token we captured from the redirect fragment — gapi.auth2
	// no longer completes redirect-mode sign-in since it was sunset.
	if (Captured && Captured.Tokens && Captured.Tokens.id_token) {
		Profile = Jelly.Connections.Google_Parse_ID_Token(Captured.Tokens.id_token);

		if (!Profile || !Profile.sub) {
			Jelly.Connections.Google_Reject_Redirect(
				Parameters,
				Lifecycle,
				"invalid_callback"
			);
			return;
		}

		if (Pending_Sign_In.Nonce && Profile.nonce != Pending_Sign_In.Nonce) {
			Jelly.Connections.Google_Reject_Redirect(
				Parameters,
				Lifecycle,
				"invalid_nonce"
			);
			return;
		}

		Jelly.Connections.Google_Captured_Redirect = null;

		if (
			Jelly.Connections.Google_Profile_Needs_Userinfo(Profile) &&
			Captured.Tokens.access_token
		) {
			Jelly.Connections.Google_Fetch_Userinfo_Profile(
				Captured.Tokens.access_token,
				function(Userinfo_Profile) {
					Profile = Jelly.Connections.Google_Merge_Profile(Profile, Userinfo_Profile);

					Jelly.Connections.Google_Submit_Redirect_Profile(
						Parameters,
						Pending_Sign_In,
						Profile,
						Lifecycle
					);
				}
			);
			return;
		}

		Jelly.Connections.Google_Submit_Redirect_Profile(
			Parameters,
			Pending_Sign_In,
			Profile,
			Lifecycle
		);
		return;
	}

	if (Captured) {
		Jelly.Connections.Google_Reject_Redirect(
			Parameters,
			Lifecycle,
			"invalid_callback"
		);
		return;
	}

	if (!Jelly.Connections.Google_Auth)
		return;

	Google_User = Jelly.Connections.Google_Auth.currentUser.get();

	if (
		!Jelly.Connections.Google_Auth.isSignedIn.get() &&
		!(
			Google_User &&
			Google_User.isSignedIn &&
			Google_User.isSignedIn()
		)
	)
		return;

	Jelly.Connections.Google_Handle_Success(
		{
			Namespace: Parameters.Namespace,
			Error_Namespace: Parameters.Error_Namespace || Pending_Sign_In.Error_Namespace
		},
		Jelly.Connections.Google_Auth.currentUser.get()
	);
};

Jelly.Connections.Google_Restore_Pending_Context = function() {
	var Pending_Sign_In = Jelly.Connections.Google_Get_Pending_Sign_In();

	if (!Pending_Sign_In)
		return;

	if (!Pending_Sign_In.Modal_URL)
		return;

	if (Jelly.Connections.Google_Uses_Callback_Page(Pending_Sign_In))
		return;

	if (Jelly.Connections.Google_Modal_Restore_Attempted)
		return;

	if (Jelly.Interface.Visible_Modal)
		return;

	Jelly.Connections.Google_Modal_Restore_Attempted = true;

	Jelly.Interface.Create_Modal({
		URL: Pending_Sign_In.Modal_URL,
		Direction: Pending_Sign_In.Modal_Direction || "Right",
		"2019_Theme": Pending_Sign_In.Modal_2019_Theme,
		Force_Minimal: Pending_Sign_In.Modal_Force_Minimal
	});
};

Jelly.Connections.Google_Register_Resume_Listeners = function(Parameters) {
	var Listener_Key = [
		Parameters.Namespace || "",
		Parameters.Intent || "",
		Parameters.Error_Namespace || ""
	].join("|");

	if (Jelly.Connections.Google_Resume_Listeners[Listener_Key])
		return;

	Jelly.Connections.Google_Resume_Listeners[Listener_Key] = true;

	Jelly.Connections.Google_When_Ready(function(auth2) {
		auth2.isSignedIn.listen(function(Is_Signed_In) {
			if (Is_Signed_In)
				Jelly.Connections.Google_Try_Resume_Sign_In(Parameters);
		});

		auth2.currentUser.listen(function() {
			Jelly.Connections.Google_Try_Resume_Sign_In(Parameters);
		});
	});
};

Jelly.Connections.Google_Handle_Click = function(Event, Parameters) {
	var Pending_Sign_In = null;

	Event.preventDefault();

	Pending_Sign_In = Jelly.Connections.Google_Set_Pending_Sign_In(Parameters);
	Jelly.Connections.Google_Track_Pending_Event(Pending_Sign_In, "Started");
	window.location.assign(Jelly.Connections.Google_Get_Authorize_URL(Pending_Sign_In));
};

Jelly.Connections.Google_Bind_Element = function(Parameters) {
	if (!Parameters.Element)
		return;

	if ($(Parameters.Element).attr("data-google-sign-in-bound") == "true")
		return;

	$(Parameters.Element).attr("data-google-sign-in-bound", "true");
	Parameters.Element.addEventListener("click", function(Event) {
		Jelly.Connections.Google_Handle_Click(Event, Parameters);
	});
};

(function() {
	var Initialize_Google_Auth = function() {
		// Wait until the Jelly.Connections namespace is actually present —
		// on reload races it can be temporarily undefined when gapi's async
		// callback fires.
		if (!window.Jelly || !window.Jelly.Connections) {
			setTimeout(Initialize_Google_Auth, 50);
			return;
		}

		Jelly.Connections.Google_Auth = gapi.auth2.init({
			client_id: Jelly.Connections.Google_Client_ID,
			cookie_policy: "single_host_origin",
			scope: "profile email",
			plugin_name: "Friends"
		});

		Jelly.Connections.Google_Auth.then(function(auth2) {
			Jelly.Connections.Google_Auth = auth2;
			Jelly.Connections.Google_Auth_Ready = true;
			Jelly.Connections.Google_Restore_Pending_Context();
			Jelly.Connections.Google_Run_Ready_Queue();
		});
	};

	$.getScript("https://apis.google.com/js/platform.js", function() {
		gapi.load("auth2", Initialize_Google_Auth);
	});
})();

Jelly.Connections.Google_Sign_In = function(Parameters) {
	Jelly.Connections.Google_Bind_Element(Parameters);
	Jelly.Connections.Google_Register_Resume_Listeners(Parameters);

	// Callback-page returns are handled without waiting for gapi.auth2
	// (redirect mode no longer completes there). The pre-paint state is shown
	// before this bundle loads; keep the real overlay up until this particular
	// Connect Social action either succeeds or presents recovery options.
	if (
		Jelly.Connections.Google_Captured_Redirect &&
		Jelly.Connections.Google_Uses_Callback_Page({Intent: Parameters.Intent})
	) {
		Jelly.Connections.Google_Show_Redirect_Overlay();

		$(function() {
			Jelly.Connections.Google_Try_Resume_Sign_In(Parameters);
		});

		return;
	}

	Jelly.Connections.Google_When_Ready(function() {
		Jelly.Connections.Google_Try_Resume_Sign_In(Parameters);
	});
};

Jelly.Connections.Google_Sign_Out = function() {
	Jelly.Connections.Google_Clear_Pending_Sign_In();
};
